var _defs, _path, _setting;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    width: 1058,
    height: 765,
    viewBox: "0 0 1058 765",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "edeGradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9ba33"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "rgba(249,186,51,1);rgba(249,186,51,0.5); rgba(249,186,51,0); rgba(249,186,51,1)",
    dur: "3s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "rgba(255,109,4,0)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "rgba(255,109,4,1); rgba(255,109,4,0); rgba(255,109,4,0.5);rgba(255,109,4,1)",
    dur: "3s",
    repeatCount: "indefinite"
  }))))), ">\r\n     ", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9806 5C40.7983 5 5 40.787 5 84.9512V680.049C5 724.213 40.7983 760 84.9806 760H973.019C1017.2 760 1053 724.213 1053 680.049V84.9512C1053 40.787 1017.2 5 973.019 5H84.9806ZM382.284 676.147H88.6606V592.261H298.401V508.408H172.575V424.555H382.284V676.147ZM969.086 676.147H466.199V592.261H885.202V508.408H760.623V424.555H969.086V676.147ZM675.46 424.555V508.408H467V424.299H550.914V424.555H675.46ZM675.716 88.8531H885.425V172.706H759.599V256.559H969.339V340.445H675.716V88.8531ZM382.54 88.8531L507.086 88.5971H591.001V172.706H382.54V88.8531ZM88.9166 88.8531H297.377V172.706H172.798V256.559H591.801V340.445H88.9166V88.8531Z",
    stroke: "#ff9b04",
    strokeWidth: 3,
    strokeDasharray: "0,0,0,10839.2119140625",
    fill: "url(#edeGradient)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: "indefinite",
    dur: "6s",
    values: "0,0,0,10839.2119140625;  0,5419.60595703125,5419.60595703125,0;            10839.2119140625,0,0,0",
    keyTimes: "0; 0.5; 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-width",
    repeatCount: "indefinite",
    values: "6;1;0;1;6",
    dur: "6s"
  }))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":4,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading2);
export default __webpack_public_path__ + "static/media/loading2.72f8b46f00f43ca87da67cff573419a1.svg";
export { ForwardRef as ReactComponent };